import { buildQuery, requestJson } from "./apiClient";

export async function listIngestionRuns(params = {}) {
  return requestJson(`/api/admin/ingestion-runs${buildQuery(params)}`);
}

export async function getIngestionRunDetail(runId) {
  return requestJson(`/api/admin/ingestion-runs/${runId}`);
}

export async function getIngestionRunLogs(runId, params = {}) {
  return requestJson(`/api/admin/ingestion-runs/${runId}/logs${buildQuery(params)}`);
}
